<template>
  <!-- <mw-dialog ref="dialog" title="正文" :appendToBody="false" size="large_large"> -->
  <mw-dialog ref="dialog" :title="title" :appendToBody="false" size="full" :before-close="closeWindow">
    <mw-ntko-editor  :defButtons="buttons" :propObject="propObject" ref="editor"/>
  </mw-dialog>
</template>
<script>
export default {
  // props: {
  //   params: {
  //    type: Object
  //   }
  // },
  data(){
    let me = this;
    let processActivity=me.$attrs.params.processActivity; //获取流程信息，用于控制按钮
    me.form = me.$attrs.params.form;
    let formObj=me.$attrs.params.form;
    let formConfig=this.$attrs.params.formConfig;
    me.formData = me.$attrs.params.formData;
    let componentTag = this.$options._componentTag;
    me.componentTag=componentTag; //是否ntko控件打开文档还是正文打开文档
    var buttons = [];
    var fileUrl = this.$attrs.params.fileUrl;
    var fileName = this.$attrs.params.fileName  || "正文";
    var fileId=this.$attrs.params.fileId;
    var editmode,fileSaveAs, FileSave, efileType;

    var afterDocOpen = this.$attrs.params.afterDocOpen;
    if (componentTag == "NtkoEditor") {
      editmode = "1";
      efileType = "JOA_ZW";
      var isShowToolbar = this.$attrs.params.isShowToolbar?this.$attrs.params.isShowToolbar:false; //打开附件时不需要工具栏
      if(isShowToolbar){
        buttons.push({id:'save',name:'保存'});
        buttons.push({id:'print',name:'打印'});
        buttons.push({id:'showCG',name:'显示草稿'});
        buttons.push({id:'showZW',name:'显示正文'});
        buttons.push({id:'xshj',name:'显示痕迹'});
        buttons.push({id:'th',name:'套红'});
        buttons.push({id:'format',name:'规范全文'});
        buttons.push({id:'filePageSetup',name:'页面设置'});
        buttons.push({id:'insertDateTime',name:'插入时间'});
        buttons.push({id:'insertFile',name:'导入文件'});
        buttons.push({id:'insertPhrase',name:'插入常用语'});
        buttons.push({id:'gz',name:'盖章'});
      }
    }else if(componentTag == "OnLineEfileEdit"){
      //附件控件打开方式
      editmode = this.$attrs.params.editmode;
      efileType = this.$attrs.params.efileType;
    }
    if (me.$attrs.params.buttons) {
      buttons = me.$attrs.params.buttons;
    }
    //获取当前人员，用于盖章加密
    let userNameObj= me.$store.getters.expUser;
    let userName="";
    if(userNameObj){
      userName=userNameObj.name;
    }
    return {
      title: fileName,
      propObject:{
        params: {
          processActivity:processActivity,  //获取流程信息，用于显示按钮
          editmode:this.$attrs.params.editable?"1":"0",
          formConfig:this.$attrs.params.formConfig, //获取控件属性
          businessId: this.$attrs.params.businessId,
          formId: this.$attrs.params.formId,
          tempBusinessId: this.$attrs.params.tempBusinessId,
          efileType: efileType,
          step: "edit",
          fileName: fileName,
          saveFileType: "",
          pk_id: this.$attrs.params.businessId,
          yzEfileLinkId: [{ id: "testid" }],
          flowModuleId: this.$attrs.params.moduleId,
          formComponentId: 'c6e11442bb26455d93b8a724e90d5f6f',
          isLoadFormData:false,
          opType: '1',
          showProgressBar: true,
          isNoCopy: true,
          isReadOnly: 0,
          isPubPDFBtn: false,
          isPrintZW:0,
          operateType:'',
          fileUrl: fileUrl,
          fileId:fileId,
          FileSave: FileSave,
          fileSaveAs: fileSaveAs,
          userName:userName
        },
        formData: me.formData,
        docFormatObject: {},
        processActivity:"",  //获取流程信息，用于显示按钮
        form : formObj,
        efileLinkId:"",
        isNewEfileDoc:"",
        isReadOnly:"",
        joaCaoGaoId:"",
        joaHeGaoId:"",
        joaZenWenId:"",
        joaPDFId:"",
        componentTag:componentTag,  //打开方式
        afterDocOpen: afterDocOpen
      },
      buttons:buttons
    }

  },
  mounted() {
    //打开对话框之前获取到对应发文格式的所有内容
    setTimeout(()=>{
      var me=this;
      if(me.componentTag == "OnLineEfileEdit"){ //ntko附件管理直接打开附件
        me.show();
      }else{
        me.getDocFormatObject();
      }
    },200)
  },
  /*
  mounted() {
    //打开对话框之前获取到对应发文格式的所有内容
    setTimeout(()=>{
      var me=this;
      if(me.componentTag == "OnLineEfileEdit"){ //ntko附件管理直接打开附件
        me.show();
      }else{
        me.getDocFormatObject();
      }
    },200)
  },
*/
  methods: {
    getDictByCode(dictcode){
      return this.mwApi.data.getDictByCode(dictcode).then(function(v){
        return v
        }
      ).catch(err=>console.log(err));
    },
    show(){
        this.mwRef('dialog').show();
    },
    closeWindow:function(){
      var me=this;
      this.mwRef('dialog').hide();
      if(me.mwRef('editor')){
        me.mwRef('editor').closeIframe();
      }
    },
    //获取到发文格式里面的所有内容
    getDocFormatObject(){
      var me=this;
      let formData=me.formData;
      me.propObject.processActivity=me.$attrs.params.processActivity;
      let attachMentList=formData['#items'];
      let joaCaoGaoId="";
      let joaHeGaoId="";
      let joaZenWenId="";
      let joaPDFId="";
      if(attachMentList && attachMentList.length>0){
        attachMentList.map(function(item,index,arr) {
          let itemType=item.type;
          let itemId=item.id;
          if(itemType=="JOA_CG" && item.mimeType!=".pdf"){joaCaoGaoId=itemId;me.propObject.joaCaoGaoId=joaCaoGaoId}
          if(itemType=="JOA_HG" && item.mimeType!=".pdf"){joaHeGaoId=itemId;me.propObject.joaHeGaoId=joaHeGaoId}
          if(itemType=="JOA_ZW" && item.mimeType!=".pdf"){joaZenWenId=itemId;me.propObject.joaZenWenId=joaZenWenId}
          if(itemType=="JOA_ZW" && item.mimeType==".pdf"){joaPDFId=itemId;me.propObject.joaPDFId=joaZenWenId}
        })
      }
      let efileLinkId=""; //直接打开文档的id
      if(joaZenWenId){
        efileLinkId=joaZenWenId;
      }else if(joaHeGaoId){
        efileLinkId=joaHeGaoId;
      }else if(joaCaoGaoId){
        efileLinkId=joaCaoGaoId;
      }else{
        efileLinkId=null;
      }
      //在编辑状态下找到发文格式，处于只读状态则直接打开文档,没有文档则提示
      let isEdit=this.$attrs.params.editable;  //true:编辑状态；false：只读状态
      if(isEdit){
        me.propObject.efileLinkId=efileLinkId;
        if(!efileLinkId) {
          me.propObject.isNewEfileDoc = true;
        }else{
          me.propObject.isNewEfileDoc = false;
        }
        me.propObject.isReadOnly=false;
        //处于编辑状态，需要获取发文格式的相关属性，书签之类的值
        var format=formData.formatid ;//发文格式的id
        if(!format && me.$attrs.params.editable){  //if(me.mwRef('editor')){
          alert("请先选择发文格式！");
          return;
        }
        this.mwApi.business.getDocumentFormat(format).then(r=> {
          if(r && r.result){
            var formatObject=this.arrangeData(r.result);
            me.propObject.docFormatObject=formatObject;
            me.show();
            //me.showEditor=true; //加载这个word控件
            //me.hasLoad=true;  //  是否已经加载了
            //this.$refs.editor.doSomeThing();
          }else{
            alert("没有找到相应的发文格式，请联系管理员！");
            return;
          }
        })
      }else{
        //只读状态
        if(!efileLinkId){
          alert("该文件还没有生成正文，请先编辑正文！")
          return;
        }else{
          me.propObject.efileLinkId=efileLinkId;
          me.propObject.isNewEfileDoc=false;
          me.propObject.isReadOnly=true;
          me.showEditor=true; //加载这个word控件
        }
      }
    },
    //整理发文格式的数据
    arrangeData(d){
      let formatObject={};
      var docData=d.doc;
      if(docData){
        formatObject.mouldFormId="c3faaec06cfae727";  //草稿，模板头，模板尾，处理单的表id
        formatObject.isTaoTouFirst=docData.fldttfs=="先套头"?true:false;  //是否先套头
        if(d.main){ //正文草稿文件
          formatObject.caoGaoDocId=d.main?d.main.id:"";  //草
          // 稿文档表id
          if(d.main["#items"] && d.main["#items"].length>0){
            formatObject.caoGaoMouldId=d.main["#items"][0].id;  //"e2bff743f408644b"
          }
        }
        if(d.head){ //模板头文件
          formatObject.headDocId=d.head?d.head.id:"";  //模板头文档表id
          if(d.head["#items"] && d.head["#items"].length>0){
            formatObject.headMouldId=d.head["#items"][0].id;  //"e2bff743f408644b"
          }
        }
        if(d.footer){ //模板尾文件
          formatObject.tailDocId=d.footer?d.footer.id:"";  //模板尾文档表id
          if(d.footer["#items"] && d.footer["#items"].length>0){
            formatObject.tailMouldId=d.footer["#items"][0].id;  //"e2bff743f408644b"
          }
        }
        /*
        暂时还没提供
        formatObject.cldMouldId=docData.fldzswjwid;  //处理单模板id
        formatObject.cldDocId=d.main?d.main.id:"";  //处理单文档表id
        */
        formatObject.fjLabelName=docData.fldfjsq;  //显示附件列表书签
        formatObject.htLabelName=docData.fldhtsq; //红头书书签
        formatObject.htLabelValue=docData.fldhtqz; //红头书签值
        formatObject.yzLabelName=docData.fldyzsq;  //印章书签
        formatObject.ffbmLabelName=docData.fldffbmsq; //封发部门书签
        formatObject.ffbmLabelValue=docData.fldffbmqz; //封发部门书签值
        //返回所有的配置信息的书签列表
        //tmplListObject
        var arrJson={};
        if(d.mainMark && d.mainMark.length>0){  //草稿中的所有书签
          arrJson=this.arrList(d.mainMark,arrJson);
        }
        if(d.headMark && d.headMark.length>0){  //模板头所有书签
          arrJson=this.arrList(d.headMark,arrJson);
        }
        if(d.footerMark && d.footerMark.length>0){  //模板尾所有书签
          arrJson=this.arrList(d.footerMark,arrJson);
        }
        formatObject.tmplListObject=arrJson;
      }
      return formatObject;
    },
    arrList(objList,arrJson){
      //fldmc：书签名称；fldqzfs：取值方式；fldqz：取值；fldxhbd：是否写回表单
      if(objList && objList.length>0){
        for(var i=0;i<objList.length;i++){
          var label={};
          label.fldmc=objList[i].fldmc; //书签名称
          label.fldqzfs=objList[i].fldqzfs; //取值方式
          label.fldqz=objList[i].fldqz; //取值
          label.fldxhbd=objList[i].fldxhbd; //是否写回表单
          label.fldyjgs=objList[i].a1cc3bf8eefb6300;//意见格式
          label.fldisnew=objList[i].fldfhzxyt;  // 是否返回最新一条
          var nameKey=label.fldmc;
          arrJson[nameKey]=label;
        }
      }
      return arrJson;
    }
  },
  destroyed(){

  }
}
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/ntko/ntko-editor.vue